import React from 'react';
import PropTypes from 'prop-types';
import RenewsAt from './RenewsAt';
import { getSubtitle } from '../utils/helpers';
import { DomainProductTypes } from '../utils/constants';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';

class GroupItems extends NamespaceConsumer {

  render() {
    const { group, language, market, currency } = this.props;

    if (group && group.items && group.items.length > 0) {
      return group.items.map((groupItem, index) => {
        if (index === 0 && !group.name && group.items.length > 1) return null; // skip first item

        const canRemoveItem = group.items.length === 1 || index > 0 && groupItem.canRemoveAlone;
        let title = groupItem.label;
        let subtitle = getSubtitle(groupItem);

        // Replace Product name with domain name if product is a type of domain
        if (DomainProductTypes.includes(groupItem.productTypeId)) {
          title = groupItem.metadata.domains[0].domain;
          subtitle = null;
        }

        return (
          <div key={ groupItem.itemId } className={ this.namespace('hc-group-item p-3') }>
            <div className={ this.namespace('ms-1') }><strong>{ title }</strong></div>
            { subtitle && <div className={ this.namespace('ms-1 text-muted') }>{ subtitle }</div> }
            <div className={ this.namespace('ms-1 text-muted') }>
              <RenewsAt item={ groupItem } language={ language } market={ market }
                currency={ currency } canRemoveItem={ canRemoveItem } />
            </div>
          </div>
        );
      }
      );
    }
    return null;
  }
}

GroupItems.propTypes = {
  ...NamespaceShape,
  group: PropTypes.object,
  currency: PropTypes.string.isRequired,
  market: PropTypes.string.isRequired,
  language: PropTypes.object.isRequired
};

export default withNamespace(GroupItems);
